/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useIngestProviders
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import AppEvents from '@veritable/common/utils/appEvents';
import api from 'client/index';
import { invalidateMetadata } from 'app-constants/queryKeys';

/**
 * Mutate for bulk provider ingestion
 *
 */
const useIngestProviders = (): UseMutationResult<Provider.IBulkPostResponseModel, IAxiosError, Provider.IBulkPostModel, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			const { data } = await api.ProvidersApi.ingestProviders({ bulkProviderPostModel: model });
			return data;
		},
		onSuccess: () => {
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useIngestProviders;
